import React from 'react';
import { LinkButton } from '../../button/Button';

// navigator is browser-only, this line lets the backend render this component
var navigator = globalThis.navigator || {
  userAgent: ''
};
var GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.milanote.milanoteApp';
var APP_STORE_URL = 'https://itunes.apple.com/us/app/milanote/id1433852790?ls=1&mt=8';
export var DynamicCTAButton = function DynamicCTAButton() {
  var userAgent = navigator.userAgent;
  var isAndroid = /Android/i.test(userAgent);
  if (isAndroid) {
    return /*#__PURE__*/React.createElement(LinkButton, {
      cta: true,
      href: GOOGLE_PLAY_URL
    }, "Download on Google Play");
  }
  var isIOS = /(iPhone|iPad)/i.test(userAgent);
  if (isIOS) {
    return /*#__PURE__*/React.createElement(LinkButton, {
      cta: true,
      href: APP_STORE_URL
    }, "Download on Apple App Store");
  }
  return /*#__PURE__*/React.createElement(LinkButton, {
    cta: true,
    href: "#signup-form"
  }, "Sign up for free");
};